export interface MyUserSurveysProps {
  tab: MyUserSurveysTabType;
  title?: string;
}

export interface MyUserSurveysTabComponentProps {
  title: string;
  onTotalCountChange?: (count: number) => void;
}

export enum MyUserSurveysTabType {
  Surveys = 'surveys',
  ActionPlans = 'action-plans',
}
